import { render } from "./NotFouldPage.vue?vue&type=template&id=2432e2a4"
import script from "./NotFouldPage.vue?vue&type=script&lang=js"
export * from "./NotFouldPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__